module.exports = ".ssf-permissions {\n  font-size: 0.75rem;\n  margin: 0;\n  padding-left: 2rem; }\n  .ssf-permissions li {\n    list-style: none; }\n    .ssf-permissions li > img {\n      padding: 0 0.6rem 0 0; }\n\n.ssf-permissions_empty {\n  font-size: 1rem;\n  font-style: italic;\n  color: #AAAAAA; }\n\n.ssf-permissions__icon {\n  color: green; }\n\n.ssf-permissions__icon_disabled {\n  height: 1rem; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/components/permissions/permissions.component.scss
// module id = 809
// module chunks = 3